import React, {useEffect, useState } from 'react';
import { Fragment } from 'react'
import axios from 'axios';
import DOMPurify from 'dompurify';
import { FaPaperPlane } from 'react-icons/fa';
import './Chatbot.css';

const Chatbot = () => {
    const [messages, setMessages] = useState([{ text: 'Bonjour, je suis votre assistant Appvise\'me, Comment puis-je vous aider ?', sender: 'ai' }]);
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [isConnected, setIsConnected] = useState(false);
    const [error, setError] = useState(null);

    const handleSend = async () => {
        if (input.trim() === '') return;
        
        let hasReceivedFirstChunk = false;

        const newMessage = { text: input, sender: 'user' };
        setMessages([...messages, newMessage]);
        setInput('');
        setLoading(true);

        
        //useEffect(() => {
            const customerId = document.getElementById("chat-customer-id").value;
            const userId = document.getElementById("chat-user-id").value;
            console.log("Customer ID " + customerId)
            const params = new URLSearchParams({
                prompt: input,
            });
            const url = `https://b3ofn9q3-n18y5235-2915.apps01.trooper.cloud/host-ai/converse/${customerId}/user/${userId}?prompt=${params}`;
            console.log("Converse on " + url);

            const eventSource = new EventSource(url);
            
            eventSource.onopen = (event) => {
                setIsConnected(true);
                setError(null);
                console.log('Connection established');
            };
            
            eventSource.onmessage = (event) => {
                try {
                    const results = JSON.parse(event.data);
                    const messageId = results.messageId;
                    //let chunkResponse = results.content;
                    //chunkResponse = DOMPurify.sanitize(chunkResponse);
                    const messageResp = results.content.split("\n").join("<br/>");
                    console.log(messageId + "-->" + messageResp);
                        
                    if (!hasReceivedFirstChunk) {
                        hasReceivedFirstChunk = true;
                        setMessages((prev) => [
                            ...prev, { id: messageId, text: messageResp, sender: 'ai' }
                            ]);
                    }else{
                        setMessages((prev) =>
                            prev.map((msg) =>
                                msg.id === messageId && msg.sender === "ai"
                                ? { ...msg, text: msg.text + messageResp }
                                : msg,
                            ),
                        );
                        //setMessages([...messages, newMessage, aiMessage]);
                        setLoading(false);
                    }
                } catch (error) {
                    console.error("Error fetching AI response", error);
                    setLoading(false);
                }
            };
            eventSource.onerror = (event) => {
                setIsConnected(false);
                // EventSource will automatically reconnect
                // Only set error if connection is completely closed
                if (eventSource.readyState === EventSource.CLOSED) {
                    setError('Connection closed. Please refresh the page.');
                }
            };
            return() => {
                    eventSource.close();
            };
        //}, [customerId, userId]);
    };

    const handleInputChange = (e) => {
        setInput(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSend();
        }
    };

    function htmlDecode(input){
        var e = document.createElement('div');
        e.innerHTML = input;
        //var result = e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
        //console.log("==>"+JSON.stringify(result));
        return e.innerHTML;
    }

    return (
        <div className="chatbot-container">
            <div className="chat-header">
                <img src="/app-assets/chatbot/ChatBot.png" alt="Chatbot Logo" className="chat-logo" />
                <div className="breadcrumb">Home &gt; Chat</div>
            </div>
            <div className="chatbox">
                {messages.map((message, index) => (
                    <div key={index} className={`message-container ${message.sender}`}>
                        <img
                            src={message.sender === 'user' ? '/app-assets/chatbot/user-icon.png' : '/app-assets/chatbot/ai-assistant.png'}
                            alt={`${message.sender} avatar`}
                            className="avatar"
                        />
                        <div className={`message ${message.sender}`}>
                             <div dangerouslySetInnerHTML={{ __html: htmlDecode(message.text) }} />
                        </div>
                    </div>
                ))}
                {loading && (
                    <div className="message-container ai">
                        <img src="/app-assets/chatbot/ai-assistant.png" alt="AI avatar" className="avatar" />
                        <div className="message ai">...</div>
                    </div>
                )}
            </div>
            <div className="input-container">
                <input
                    type="text"
                    value={input}
                    onChange={handleInputChange}
                    onKeyPress={handleKeyPress}
                    placeholder="Type your message..."
                />
                <button onClick={handleSend}>
                    <FaPaperPlane />
                </button>
            </div>
        </div>
    );
};

export default Chatbot;
